export const SUCCESS_MESSAGE = 'SUCCESS_MESSAGE';
export const CLEAR_SUCCESS_MESSAGE = 'CLEAR_SUCCESS_MESSAGE';

export const ERROR_MESSAGE = 'ERROR_MESSAGE';
export const CLEAR_ERROR_MESSAGE = 'CLEAR_ERROR_MESSAGE';

export const WARNING_MESSAGE = 'WARNING_MESSAGE';
export const CLEAR_WARNING_MESSAGE = 'CLEAR_WARNING_MESSAGE';
